import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import {
  getActiveDamageTickets,
  getActiveDamageTicketsActionState,
  getResidentAppSettings,
  LoadActiveDamageTickets,
  LoadActiveDamageTicketsHQ,
} from '../../+state';
import { ITicketResidentOverviewEdge } from '../../models';
import { ResolverCommonService } from './resolver-common.service';
import { CustomerService } from '../customer';
import { TicketingVersion } from '../../models';
import { map, filter, take, firstValueFrom } from 'rxjs';
import { Store } from '@ngrx/store';

export const DamageTicketsActiveResolver: ResolveFn<ITicketResidentOverviewEdge[]> = (
  route: ActivatedRouteSnapshot
) => {
  const common = inject(ResolverCommonService);
  const customerService = inject(CustomerService);
  const store = inject(Store);
  /**
   * don't send requests for active damage tickets if the B&O Damage Tool is used
   */
  const bAndODamageFlow = customerService.showBandODamageFlow();
  if (bAndODamageFlow) {
    return null;
  }
  const { resolverWaitForData } = route.data;

  firstValueFrom(
    store.select(getResidentAppSettings).pipe(
      map(response => response?.ticketingVersion),
      filter(response => response !== null),
      take(1)
    )
  ).then(version => {
    return common.resolveHandler<ITicketResidentOverviewEdge[]>(
      getActiveDamageTicketsActionState,
      version === TicketingVersion.HIERARCHICAL
        ? LoadActiveDamageTicketsHQ({ offset: 0, limit: 20 })
        : LoadActiveDamageTickets({ offset: 0, limit: 20 }),
      getActiveDamageTickets,
      resolverWaitForData
    );
  });
};
